export default __webpack_public_path__ + "static/media/Comfortaa-Medium.77aab719.ttf";